import React from "react";
import Header from "../../header";
import TopActionsComponent from "../../top-actions-component";
import PurchaseRequisitionAddModal from "./paper-add-modal";
import PurchaseRequisitionEditModal from "./paper-edit-modal";
import { Constants } from "../../../constants";
import RedirectIfNotLogged from "../../menu/redirect-if-not-logged";
import { CircularProgress, FlatButton, TextField } from "material-ui";
import SearchFilterChip from "../../search/SearchFilterChip";
import SegmentedFilter from "../../segmented-filter";
import TablePaper from "./paper-table";
import { connect } from "react-redux";
import * as RequisitionTypes from "../../../general/paper-state";
import request from "../../../config/axios-config";
import * as ErrorAction from "../../../redux/action/error-action";
import * as validator from "../../../general/validators/validator";
import { Pagination } from "react-bootstrap";
import { PrintComponent } from "../../print/PrintComponent";
import { PrintDialog } from "../../print/PrintDialog";

let fileSaver = require("file-saver");

const FILTER_ALL = 0;
const FILTER_APROVED = 1;
const FILTER_IN_PROGRESS = 2;
const FILTER_REJECTED = 3;
const FILTER_BY_ME = 4;
const FILTER_DRAFT = 5;

const FILTER_PARAMS = {
  [FILTER_ALL]: "all",
  [FILTER_APROVED]: "approved",
  [FILTER_IN_PROGRESS]: "progress",
  [FILTER_REJECTED]: "rejected",
  [FILTER_BY_ME]: "mine",
  [FILTER_DRAFT]: "draft",
};

function filterValueForParam(param) {
  const entry = Object.keys(FILTER_PARAMS).find(
    (key) => FILTER_PARAMS[key] === param,
  );
  return entry === undefined ? FILTER_ALL : parseInt(entry, 10);
}

class PaperPage extends React.Component {
  constructor(props) {
    super(props);
    const urlParams = new URLSearchParams(props.location.search);
    this.state = {
      data: [],
      wasDataLoaded: false,
      showPrintDialog: false,
      printPaper: null,
      lastPage: true,
      showAdd: false,
      showEdit: false,
      forceLogin: false,
      editData: {},
      loadingData: false,
      page: 0,
      activePage: 1,
      emptyData: false,
      filterValue: filterValueForParam(urlParams.get("filter")),
      searchWords: urlParams.get("q") || "",
      totalPages: 0,
      downloadingDoc: false,
      downloadingReport: false,
      reportYear: new Date().getFullYear(),
    };
  }

  componentDidMount() {
    this.props.hideError();
    this.refreshData(this.props.match.params.page);
  }

  componentDidUpdate(prevProps) {
    // Re-sync when the URL changes underneath us (e.g. a click in the global
    // search while this page is already mounted). Our own pushes produce a URL
    // identical to the current state, so this stays a no-op for them.
    if (prevProps.location.search !== this.props.location.search) {
      const urlParams = new URLSearchParams(this.props.location.search);
      const urlQuery = (urlParams.get("q") || "").trim();
      const urlFilter = filterValueForParam(urlParams.get("filter"));
      if (
        urlQuery !== this.state.searchWords.trim() ||
        urlFilter !== this.state.filterValue
      ) {
        this.setState(
          { searchWords: urlQuery, filterValue: urlFilter, page: 0 },
          () => this.refreshData(0),
        );
      }
    }
  }

  componentWillUnmount() {
    this.props.hideError();
    this.setState({ wasDataLoaded: false });
  }

  pushListUrl = (page) => {
    this.props.history.push("/app/referate/" + page + this.buildListQuery());
  };

  onFilterChanged = (event, index, value) => {
    this.setState({ filterValue: value, page: 0 }, () => {
      this.pushListUrl(0);
      this.refreshData(0);
    });
  };

  onClearSearch = () => {
    this.setState({ searchWords: "", page: 0 }, () => {
      this.pushListUrl(0);
      this.refreshData(0);
    });
  };

  refreshData = (page) => {
    this.props.hideError();
    this.setState({ loadingData: true });
    if (page === undefined || page === null) {
      page = 0;
    }
    let query = this.buildListQuery();

    this.props
      .getData(page, query)
      .then((response) => {
        let isEmptyData =
          !response.data.content || response.data.content.length === 0;
        this.setState({
          data: response.data.content,
          lastPage: response.data.last,
          loadingData: false,
          emptyData: isEmptyData,
          totalPages: response.data.totalPages,
        });
      })
      .catch((err) => {
        this.props.showError("A aparut o eroare. Va rog reincercati!");
        this.setState({ loadingData: false });
      });
  };

  getFilterParam = () => {
    return FILTER_PARAMS[this.state.filterValue] || "all";
  };

  buildListQuery = () => {
    let query = "?filter=" + this.getFilterParam();
    if (!validator.isEmpty(this.state.searchWords)) {
      query += "&q=" + encodeURIComponent(this.state.searchWords.trim());
    }
    return query;
  };

  onAddClicked = (forNextYear) => {
    this.setState({ showAdd: true, addData: null, forNextYear: forNextYear });
    this.props.onDialogVisible(true);
  };

  onEditClicked = (el) => {
    if (RequisitionTypes.isDraft(el.state)) {
      this.setState({ addData: el, showAdd: true });
    } else {
      this.setState({ editData: el, showEdit: true });
    }

    this.props.onDialogVisible(true);
  };

  onDeleteClicked = (paper) => {
    if (RequisitionTypes.isDraft(paper.state)) {
      request({
        url: "/paper/delete/draft/" + paper.id,
        method: "post",
      })
        .then((t) => {
          let index = this.state.data.indexOf(paper);
          let papers = this.state.data;
          papers.splice(index, 1);
          if (index !== -1) {
            this.setState({
              data: papers,
            });
          } else {
            this.props.showError(
              "Referatul nu a putut fi sters. Incercati din nou",
            );
          }
        })
        .catch((err) => {
          this.props.showError(
            "Referatul nu a putut fi sters. Incercati din nou",
          );
        });
    }
  };

  editFinished = (shouldRefresh) => {
    this.setState({ showEdit: false });
    this.props.onDialogVisible(false);
  };

  onAddModalCancel = () => {
    this.setState({ showAdd: false });
    this.props.onDialogVisible(false);
  };

  addFinished = () => {
    this.setState({ showAdd: false, addData: null });
    this.refreshData(this.state.page);
    this.props.onDialogVisible(false);
  };

  onFileDownloadClick = (paper, isPdf) => {
    let url = Constants.SERVER_ENDPOINT + "/document/docx/" + paper.id;
    if (isPdf) {
      url = Constants.SERVER_ENDPOINT + "/document/pdf/" + paper.id;
    }
    this.showDownloadingProgress(true, paper);
    this.props.hideError();
    request({
      url: url,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        const suggestedFileName = response.headers.filename;
        const effectiveFileName =
          suggestedFileName === undefined
            ? paper.id + ".docx"
            : suggestedFileName;
        fileSaver.saveAs(response.data, effectiveFileName);
        this.showDownloadingProgress(false, paper);
      })
      .catch((response) => {
        console.error(
          "Could not Download the Docx report from the backend.",
          response,
        );
        this.props.showError(
          "Descarcarea documentului a esuat! Va rog reincercati!",
        );
        this.showDownloadingProgress(false, paper);
      });
  };

  onReportDownloadClick = () => {
    let url =
      Constants.SERVER_ENDPOINT +
      "/document/papers/excel?year=" +
      this.state.reportYear;
    this.setState({ downloadingReport: true });
    request({
      url: url,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        const suggestedFileName = response.headers.filename;
        const effectiveFileName =
          suggestedFileName === undefined
            ? "raport referate.xlsx"
            : suggestedFileName;
        fileSaver.saveAs(response.data, effectiveFileName);
        this.setState({ downloadingReport: false });
      })
      .catch((response) => {
        console.error(
          "Could not Download the Docx report from the backend.",
          response,
        );
        this.props.showError(
          "Descarcarea documentului a esuat! Va rog reincercati!",
        );
        this.setState({ downloadingReport: false });
      });
  };

  onDetailedReportDownloadClick = () => {
    let url =
      Constants.SERVER_ENDPOINT +
      "/document/papers-products/excel?year=" +
      this.state.reportYear;
    this.setState({ downloadingReport: true });
    request({
      url: url,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        const suggestedFileName = response.headers.filename;
        const effectiveFileName =
          suggestedFileName === undefined
            ? "raport referate detaliat.xlsx"
            : suggestedFileName;
        fileSaver.saveAs(response.data, effectiveFileName);
        this.setState({ downloadingReport: false });
      })
      .catch((response) => {
        console.error(
          "Could not Download the detailed Excel report from the backend.",
          response,
        );
        this.props.showError(
          "Descarcarea documentului a esuat! Va rog reincercati!",
        );
        this.setState({ downloadingReport: false });
      });
  };

  showDownloadingProgress = (visible, paper) => {
    let index = this.state.data.indexOf(paper);
    if (index !== -1) {
      let newData = this.state.data;
      newData[index].downloadingDoc = visible;
      this.setState({
        downloadingDoc: visible,
        data: newData,
      });
    }
  };

  onApproveFinished = (paper) => {
    if (this.props.removeAfterApproval) {
      let index = this.state.data.indexOf(paper);
      if (index !== -1) {
        let newData = this.state.data;
        newData.splice(index, 1);
        this.setState({
          data: newData,
        });
      }
    } else {
      let index = this.state.data.indexOf(paper);
      if (index !== -1) {
        let newData = this.state.data;
        newData[index] = paper;
        this.setState({
          data: newData,
        });
      }
    }
    this.props.afterPaperApproved();
  };

  handlePageChanged = (newPage) => {
    const newPageInt = parseInt(newPage) - 1;
    this.setState(
      {
        page: newPageInt,
      },
      () => {
        this.refreshData(newPageInt);
      },
    );
    this.pushListUrl(newPageInt);
  };

  onClickPrint = (paper) => {
    console.log("lucitest here", paper);
    this.setState({
      showPrintDialog: true,
      printPaper: paper,
    });

    this.props.onDialogVisible(true);
  };

  onSetPaperAsPrinted = (paper) => {
    console.log("lucitest paper", paper);

    this.setState({
      data: this.state.data.map((t) => {
        if (t.id === paper.id) {
          return {
            ...t,
            printed: true,
          };
        } else {
          return t;
        }
      }),
    });

    request({
      url: "/paper/setIsPrinted/" + paper.id,
      method: "post",
    })
      .then((t) => {
        console.log("Set as printed", t);
      })
      .catch((err) => {
        this.props.showError(
          "Referatul nu a putut fi finalizat. Incercati din nou",
        );
      });
  };

  render() {
    const paginationButtons = (
      <div>
        <div>
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={10}
            items={this.state.totalPages}
            activePage={this.state.page + 1}
            onSelect={this.handlePageChanged}
          />
        </div>
      </div>
    );

    // The global search in the top bar is the only search input; this chip
    // just surfaces the term this list was deep-linked with, and clears it.
    const searchDiv = (
      <div style={{ display: "inline-block", marginLeft: "12px", verticalAlign: "middle" }}>
        <SearchFilterChip
          query={this.state.searchWords.trim()}
          onClear={this.onClearSearch}
        />
      </div>
    );

    const filterOptions = [
      { value: FILTER_ALL, label: "Toate" },
      { value: FILTER_APROVED, label: "Aprobate" },
      { value: FILTER_IN_PROGRESS, label: "In aprobare" },
      { value: FILTER_REJECTED, label: "Respinse" },
    ];
    if (this.props.isInApprovalFlow && this.props.userDepartment) {
      filterOptions.push({ value: FILTER_BY_ME, label: "Create de mine" });
    }
    if (!this.props.isInApprovalFlow) {
      filterOptions.push({ value: FILTER_DRAFT, label: "Drafturi" });
    }

    const filterDiv = (
      <React.Fragment>
        {!this.props.needApprovalPage && (
          <SegmentedFilter
            options={filterOptions}
            value={this.state.filterValue}
            onChange={(value) => this.onFilterChanged(null, null, value)}
          />
        )}
        {searchDiv}
      </React.Fragment>
    );

    const downloadIcon = (
      <i className="material-icons" style={{ fontSize: 18, verticalAlign: "middle" }}>
        file_download
      </i>
    );

    const downloadPaperReport = (
      <React.Fragment>
        <TextField
          style={{ width: 64 }}
          floatingLabelText="Anul"
          type={"number"}
          value={this.state.reportYear}
          onChange={(e) => {
            this.setState({ reportYear: e.target.value });
          }}
        />

        <FlatButton
          className="ds-toolbar-btn"
          primary
          icon={downloadIcon}
          label={"Excel"}
          onClick={() => this.onReportDownloadClick()}
        />

        <FlatButton
          className="ds-toolbar-btn"
          primary
          icon={downloadIcon}
          label={"Excel detaliat"}
          onClick={() => this.onDetailedReportDownloadClick()}
        />

        {this.state.downloadingReport && (
          <CircularProgress size={24} style={{ marginBottom: 8 }} />
        )}
      </React.Fragment>
    );

    return (
      <div>
        <RedirectIfNotLogged />

        {this.state.showAdd === true ? (
          <PurchaseRequisitionAddModal
            title={"Adauga referat"}
            onCancel={this.onAddModalCancel}
            addFinished={this.addFinished}
            data={this.state.addData}
            forNextYear={this.state.forNextYear}
          />
        ) : (
          ""
        )}

        {this.state.showEdit ? (
          <PurchaseRequisitionEditModal
            title={
              "Editeaza referat: " +
              this.state.editData.yearId +
              "/" +
              this.state.editData.createdYear
            }
            onCancel={this.editFinished}
            data={this.state.editData}
            canDownload={true}
            canEditPapers={this.state.canEditPapers}
            canSetArticolBugetar={this.state.canSetArticolBugetar}
            downloadingDoc={this.state.downloadingDoc}
            onApproveFinished={this.onApproveFinished}
            onFileDownloadClick={this.onFileDownloadClick}
            onClickPrint={this.onClickPrint}
          />
        ) : (
          ""
        )}

        <Header title={this.props.title} />
        <div className="ds-toolbar ds-toolbar--baseline">
          {!this.props.needApprovalPage && filterDiv}
          <div className="ds-toolbar-spacer" />
          {!this.state.loadingData &&
            this.props.userDepartment &&
            !this.props.needApprovalPage && (
              <TopActionsComponent onAddClicked={this.onAddClicked} />
            )}
        </div>
        <div>
          {!this.state.loadingData && this.props.canSeePapersExcelReport && (
            <div className="ds-toolbar ds-toolbar--baseline">
              {downloadPaperReport}
            </div>
          )}

          {this.state.emptyData && (
            <div className="ds-empty">
              <h3>
                {!validator.isEmpty(this.state.searchWords)
                  ? "Niciun rezultat pentru cautare."
                  : this.props.emptyDataText}
              </h3>
            </div>
          )}

          {this.state.showPrintDialog && this.state.printPaper && (
            <PrintDialog
              paper={this.state.printPaper}
              onClose={() => {
                this.setState({
                  showPrintDialog: false,
                });

                this.props.onDialogVisible(true);
              }}
            />
          )}

          {this.state.loadingData ? (
            <div style={{ textAlign: "center", padding: "48px 0" }}>
              <CircularProgress />
            </div>
          ) : (
            !this.state.emptyData && (
              <div>
                <TablePaper
                  data={this.state.data}
                  canEdit={true}
                  onDeleteClicked={this.onDeleteClicked}
                  onEditClicked={this.onEditClicked}
                  onFileDownloadClick={this.onFileDownloadClick}
                  onClickPrint={this.onClickPrint}
                  canSetPaperAsPrinted={this.props.canSetPaperAsPrinted}
                  onSetPaperAsPrinted={this.onSetPaperAsPrinted}
                />
                {!this.props.needApprovalPage &&
                  this.state.totalPages > 0 &&
                  paginationButtons}
              </div>
            )
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    userDepartment: state.login.user.department,
    isInApprovalFlow: state.login.user.isInApprovalFlow,
    canSeePapersExcelReport: state.login.user.canSeePapersExcelReport,
    canSeeApprovedPapers: state.login.user.canSeeApprovedPapers,
    canSeeAllPapers: state.login.user.canSeeAllPapers,
    canSetPaperAsPrinted: state.login.user.canSetPaperAsPrinted,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showError: (text) => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PaperPage);
